import { AfterViewInit, Component, Input, OnInit} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-share-tooltip',
  templateUrl: './share-tooltip.component.html',
  styleUrls: ['./share-tooltip.component.scss']
})
export class ShareTooltipComponent implements OnInit, AfterViewInit {
  @Input() config;
  @Input() url: string;

  constructor(private clipboard: Clipboard) { }

  ngOnInit(): void { }

  ngAfterViewInit() { }

  copyLink() {
    this.clipboard.copy(this.url);
  }

  brandsPage() {
    if (this.url.includes('brands')) {
      return true;
    }
    return false;
  }

  urlImage() {
    const splitted = this.url.split('/');
    const nameCompany = splitted[splitted.length - 1].substring(0, splitted[splitted.length - 1].length - 7);
    if (this.url.includes('fr')) {
      return '/assets/image-share/' + nameCompany + '_fr.png';
    }
    if (this.url.includes('es')) {
      return '/assets/image-share/' + nameCompany + '_es.png';
    }
    if (this.url.includes('en')) {
      return '/assets/image-share/' + nameCompany + '_en.png';
    }
  }

  shareLIN() {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`);
  }
}
